// 彩票類的常用function都放這邊
import { ruleCodeMapping } from '@/utils/lotteryDictionary'
import { get } from 'lodash'
const getLotteryType = (lotteryCode) => {
  switch (lotteryCode) {
    // 六合彩
    case 'hk6': // 香港六合彩
    case 'am6': // 澳門六合彩
      return 'hk6'

    default:
      return 'shk6'
  }
}

const getRulesByCode = (lotteryCode) => {
  const lotteryType = getLotteryType(lotteryCode)
  switch (lotteryType) {
    case 'hk6': // 六合彩
      return ['shengXiao', 'wuXing']
    case '11x5': // 11選5
    case 'ssc': // 時時彩
      return ['zongHe', 'zongHeDaXiao', 'zongHeDanShuang', 'longHu']
    case 'pk10':
      return ['guanYaHe', 'guanYaHeDaXiao', 'guanYaHeDanShuang', 'zuLongHu']
    case 'k3':
      return ['zongHe', 'zongHeDaXiao', 'zongHeDanShuang']
    case 'xy28':
    case 'others':
    default:
      console.warn(`[getRuleString]: parameter "lotteryCode" ${lotteryCode} match failed, return blank array instead`)
      return []
  }
}

const setRulesText = (lotteryCode, periodData) => {
  const lotteryType = getLotteryType(lotteryCode)

  switch (lotteryType) {
    case 'hk6': // 六合彩
      return _rule_hk6(periodData)
    case '11x5': // 11選5
    case 'ssc': // 時時彩
      return _rule_ssc(periodData)
    case 'pk10':
      return _rule_pk10(periodData)
    case 'k3':
      return _rule_k3(periodData)
    case 'xy28':
    case 'others':
    default:
      console.warn('setRuleText: lotteryType 對應失敗! 將回傳空陣列.', lotteryType)
      return []
  }

  function _rule_hk6(periodData) {
    let returnArray = []

    let shengXiao = []
    let wuXing = []

    // 龍虎/五行
    if (!(get(periodData, periodData.ruleDetail.shengXiao) instanceof Array)) {
      console.warn('setRuleText: 六合彩缺少shengXiao 資料! 將使用空陣列')
    } else {
      shengXiao = periodData.ruleDetail.shengXiao
    }
    if (!(get(periodData, periodData.ruleDetail.wuXing) instanceof Array)) {
      console.warn('setRuleText: 六合彩缺少wuXing 資料! 將使用空陣列')
    } else {
      wuXing = periodData.ruleDetail.wuXing
    }
    if (shengXiao.length !== wuXing.length) {
      console.warn('生肖和五行的陣列長度不一致! 將回傳空陣列', shengXiao, wuXing)
      returnArray = []
    }

    for (let i = 0; i < shengXiao.length; i++) {
      const shengXiaoText = ruleCodeMapping[shengXiao[i]]
      const wuXingText = ruleCodeMapping[wuXing[i]]

      const text = `${shengXiaoText}/${wuXingText}`
      const pattern = '${shengXiaoText}/${wuXingText}'
      returnArray.push({ pattern, text })
    }

    return returnArray
  }
  function _rule_ssc(periodData) {
    // 合
    let zongHeData = get(periodData, periodData.ruleDetail.zongHe)
    if (typeof zongHeData === 'undefined') {
      console.warn('時時彩缺少 合 的資料，將使用空陣列!')
      zongHeData = []
    }
    const zongHe = [zongHeData[0]]
    // 大小
    let zongHeDaXiaoData = get(periodData, periodData.ruleDetail.zongHeDaXiao)
    if (typeof zongHeDaXiaoData === 'undefined') {
      console.warn('時時彩缺少 大小 的資料，將使用空陣列!')
      zongHeDaXiaoData = []
    }
    const zongHeDaXiao = [zongHeDaXiaoData[0]]
    // 單雙
    let zongHeDanShuangData = get(periodData, periodData.ruleDetail.zongHeDanShuang)
    if (typeof zongHeDanShuangData === 'undefined') {
      console.warn('時時彩缺少 單雙 的資料，將使用空陣列!')
      zongHeDanShuangData = []
    }
    const zongHeDanShuang = [zongHeDanShuangData[0]]
    // 龍虎
    let longHuData = get(periodData, periodData.ruleDetail.longHu)
    if (typeof longHuData === 'undefined') {
      console.warn('時時彩缺少 龍虎 的資料，將使用空字串!')
      longHuData = ''
    }
    const longHu = longHuData

    const combineList = zongHe.concat(zongHeDaXiao, zongHeDanShuang, longHu)

    const returnArray = combineList.map((ruleItem) => {
      const text = ruleCodeMapping[ruleItem] ? ruleCodeMapping[ruleItem] : ruleItem
      const pattern = ruleItem

      return { text, pattern }
    })

    return returnArray
  }
  function _rule_pk10(periodData) {
    // 冠亞合
    let guanYaHeData = get(periodData, periodData.ruleDetail.guanYaHe)
    if (typeof guanYaHeData === 'undefined') {
      console.warn('pk10 缺少 冠亞合 的資料，將使用空字串!')
      guanYaHeData = ''
    }
    const guanYaHe = [guanYaHeData]
    // 冠亞大小
    let guanYaHeDaXiaoData = get(periodData, periodData.ruleDetail.guanYaHeDaXiao)
    if (typeof guanYaHeDaXiaoData === 'undefined') {
      console.warn('pk10 缺少 冠亞大小 的資料，將使用空陣列!')
      guanYaHeDaXiaoData = ''
    }
    const guanYaHeDaXiao = guanYaHeDaXiaoData
    // 冠亞單雙
    let guanYaHeDanShuangData = get(periodData, periodData.ruleDetail.guanYaHeDanShuang)
    if (typeof guanYaHeDanShuangData === 'undefined') {
      console.warn('pk10 缺少 冠亞單雙 的資料，將使用空陣列!')
      guanYaHeDanShuangData = ''
    }
    const guanYaHeDanShuang = guanYaHeDanShuangData
    // 龍虎陣列
    let zuLongHuData = get(periodData, periodData.ruleDetail.zuLongHu)
    if (typeof zuLongHuData === 'undefined') {
      console.warn('pk10 缺少 龍虎陣列 的資料，將使用空陣列!')
      zuLongHuData = ''
    }
    const zuLongHu = zuLongHuData

    const combineList = guanYaHe.concat(guanYaHeDaXiao, guanYaHeDanShuang, zuLongHu)

    const returnArray = combineList.map((ruleItem) => {
      const text = ruleCodeMapping[ruleItem] ? ruleCodeMapping[ruleItem] : ruleItem
      const pattern = ruleItem

      return { text, pattern }
    })

    return returnArray
  }
  function _rule_k3(periodData) {
    let zongHeData = get(periodData, periodData.ruleDetail.zongHe)
    if (!zongHeData) {
      console.warn('缺少zongHe 的資料，將使用空陣列')
      zongHeData = []
    }
    const zongHe = [zongHeData[0]]

    let zongHeDaXiaoData = get(periodData, periodData.ruleDetail.zongHeDaXiao)
    if (!zongHeDaXiaoData) {
      console.warn('缺少zongHeDaXiao 的資料，將使用空陣列')
      zongHeDaXiaoData = []
    }
    const zongHeDaXiao = [zongHeDaXiaoData[0]]

    let zongHeDanShuangData = get(periodData, periodData.ruleDetail.zongHeDanShuang)
    if (!zongHeDanShuangData) {
      console.warn('缺少zongHeDanShuang 的資料，將使用空陣列')
      zongHeDanShuangData = []
    }
    const zongHeDanShuang = [zongHeDanShuangData[0]]

    const combineList = zongHe.concat(zongHeDaXiao, zongHeDanShuang)

    const returnArray = combineList.map((ruleItem) => {
      const text = ruleCodeMapping[ruleItem] ? ruleCodeMapping[ruleItem] : ruleItem
      const pattern = ruleItem

      return { text, pattern }
    })

    return returnArray
  }
}

const isCodeHk6 = function(lotteryCode) {
  return getLotteryType(lotteryCode) === 'hk6' && lotteryCode === 'hk6'
}

const hmList = {
  hmList() {
    const lotteryType = this.lotteryType

    switch (lotteryType) {
      case 'ssc':
        return (new Array(5)).fill().map((nothing, index) => ({ key: `hm${index + 1}` }))
      case 'pk10':
        return (new Array(10)).fill().map((nothing, index) => ({ key: `hm${index + 1}` }))
      case '11x5':
        return (new Array(5)).fill().map((nothing, index) => ({ key: `hm${index + 1}` }))
      case 'k3':
        return (new Array(3)).fill().map((nothing, index) => ({ key: `hm${index + 1}` }))
      default:
        console.warn('hmList: 透過lotteryType 取得對應的號碼列表失敗! 將使用空陣列.', lotteryType)
        return []
    }
  }
}

const numList = {
  numList() {
    const trendType = this.$options.name
    const lotteryType = this.lotteryType

    switch (trendType) {
      case 'PositionBasicTrend':
        return _basicTrend(lotteryType)
      case 'PositionLyeTrend':
        return _lyeTrend()
      case 'PositionSideTrend':
        return _sideTrend(lotteryType)
      case 'PositionSpjTrend':
        return _spjTrend()
      default:
        console.warn(`numList: 對比trendType 失敗! 將使用空陣列`)
        return []
    }

    function _basicTrend(lotteryType) {
      let returnArray = []

      switch (lotteryType) {
        case 'ssc':
          returnArray = (new Array(10)).fill().map((nothing, index) => ({ label: `L${index}`, key: `num${index}` }))
          return returnArray
        case 'pk10':
          returnArray = (new Array(9)).fill().map((nothing, index) => ({ label: `L${index + 1}`, key: `num${index + 1}` }))
          returnArray.push({
            label: '10',
            key: 'num10'
          })
          return returnArray
        case '11x5':
          returnArray = (new Array(9)).fill().map((nothing, index) => ({ label: `L${index + 1}`, key: `num${index + 1}` }))
          returnArray.push({
            label: '10',
            key: 'num10'
          }, {
            label: '11',
            key: 'num11'
          })
          return returnArray
        case 'k3':
          returnArray = (new Array(6)).fill().map((nothing, index) => ({ label: `L${index + 1}`, key: `num${index + 1}` }))
          return returnArray
        default:
          console.warn('_basicTrend: numList: 透過lotteryType 取得對應的location 列表失敗! 將使用空陣列', lotteryType)
          return []
      }
    }
    function _lyeTrend() {
      return (new Array(3)).fill().map((nothing, index) => ({ label: index.toString(), key: `num${index}` }))
    }
    function _sideTrend(lotteryType) {
      let keyList = []
      switch (lotteryType) {
        case 'ssc':
        case 'pk10':
        case 'k3':
          // 大小-大, 大小-小, 單雙-單, 單雙-雙, 質合-質, 質合-合
          keyList = ['daxiao_da', 'daxiao_xiao', 'danshuang_dan', 'danshuang_shuang', 'jhihHe_jhih', 'jhihHe_he']
          return keyList.map((key) => ({ key }))
        case '11x5':
          keyList = ['daxiao_da', 'daxiao_xiao', 'daxiao_he', 'danshuang_dan', 'danshuang_shuang', 'danshuang_he', 'jhihHe_jhih', 'jhihHe_he']
          // 大小-大, 大小-小, 大小-和, 單雙-單, 單雙-雙, 單雙-和, 質合-質, 質合-合
          return keyList.map((key) => ({ key }))
        default:
          console.warn('_lyeTrend: numList: 透過lotteryType 取得對應的location 列表失敗! 將使用空陣列', lotteryType)
          return []
      }
    }
    function _spjTrend() {
      return [
        { key: 'shengPingJiang_sheng', label: '升' },
        { key: 'shengPingJiang_ping', label: '平' },
        { key: 'shengPingJiang_jiang', label: '降' }
      ]
    }
  }
}

const isLotteryType = {
  isTypeHk6() {
    return getLotteryType(this.lotteryCode) === 'hk6'
  },
  isTypeSsc() {
    return getLotteryType(this.lotteryCode) === 'ssc'
  },
  isTypePk10() {
    return getLotteryType(this.lotteryCode) === 'pk10'
  },
  isTypeXy28() {
    return getLotteryType(this.lotteryCode) === 'xy28'
  },
  isType11x5() {
    return getLotteryType(this.lotteryCode) === '11x5'
  },
  isTypeK3() {
    return getLotteryType(this.lotteryCode) === 'k3'
  }
}

// function內的className需再配合設計
const setLotteryTypeClass = function(lotteryCode) {
  if (lotteryCode === 'cqssc') return 'zodiac-img-balls'
  const lotteryType = getLotteryType(lotteryCode)
  switch (lotteryType) {
    case 'hk6': // 六合彩
      return 'multi-img-balls'
    case '11x5': // 11選5
    case 'ssc': // 時時彩
      return 'img_balls'
    case 'pk10': // pk10
      return 'circl-ball'

    // 下面彩種的類型className待確認
    // case 'xy28': // 幸運28
      // return '幸運28-class-name'
    case 'k3': // 快3
      return 'dice-ball'
    // case 'others': // 其他
    //   return 'other-class-name'
    default:
      console.error(`[setLotteryTypeClass]: lotteryType ${lotteryType} matched failed, return blank string.`)
      return ''
  }

  /*
    大乐透
    img_balls*/
}

// function內的className需再配合設計
const setHk6BallColor = function(num, colorMap = {}) {
  const ballNum = Number(num)
  const redBall = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46]
  const blueBall = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48]
  const greenBall = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]
  if (redBall.includes(ballNum)) {
    return colorMap['red'] || 'ball-red'
  }
  if (blueBall.includes(ballNum)) {
    return colorMap['blue'] || 'ball-blue'
  }
  if (greenBall.includes(ballNum)) {
    return colorMap['green'] || 'ball-green'
  }
}

// function內的className需再配合設計
const setCqSscBallColor = function(number) {
  switch (number) {
    case 0:
      return 'rat'
    case 1:
      return 'tiger'
    case 2:
      return 'rabbit'
    case 3:
      return 'dragon'
    case 4:
      return 'snake'
    case 5:
      return 'horse'
    case 6:
      return 'sheep'
    case 7:
      return 'monkey'
    case 8:
      return 'chicken'
    case 9:
      return 'pig'
  }
}

// function內的className需再配合設計
const setBallColor = (number, code) => {
  const lotteryType = getLotteryType(code)
  let pk10Ballnum = 0
  switch (lotteryType) {
    case 'hk6': // 六合彩
      return setHk6BallColor(number)
    case '11x5': // 11選5
    case 'ssc': // 時時彩
      // 重慶時時彩有特殊樣式
      if (code === 'cqssc') {
        return setCqSscBallColor(number)
      }
      return 'ball-red'
    case 'pk10':
      pk10Ballnum = number > 9 ? number : `0${number}`
      return `ball-${pk10Ballnum}`
    case 'k3':
      return `ball-0${number}`

    // 下面彩種的顏色className待確認
    // case 'xy28':
    //   return 'xy28-color-ball'
    //   return 'k3-color-ball'
    // case 'others':
    //   return 'others-color-ball'
    default:
      console.warn('setBallColor: code 參數比對失敗，將使用香港六合彩.', code)
      return setHk6BallColor(number)
  }
}

export {
  getLotteryType,
  setLotteryTypeClass,
  getRulesByCode,
  setRulesText,
  isCodeHk6,
  hmList,
  numList,
  isLotteryType,
  setHk6BallColor,
  setCqSscBallColor,
  setBallColor
}
